// i18n.js — Texte für die neue Oberfläche. Der Server rendert sie als JSON in
// <script type="application/json" id="texte">{{JS_TEXTE:common,ui,…}}</script>.
//   t('ui.save') · t('app2.nights', { n: 3 }) · plural('app2.spots', n)
// Fehlender Schlüssel zeigt den Schlüssel selbst (fällt auf, Test fängt ihn).
let T = null;
function load() {
  if (T) return T;
  try { T = JSON.parse((typeof document !== 'undefined' && document.getElementById('texte')?.textContent) || '{}') || {}; } catch { T = {}; }
  return T;
}
/** Nur für Tests: Texte direkt setzen. */
export function _setTexts(obj) { T = obj; }

export function t(key, vars) {
  const d = load();
  const s = Object.prototype.hasOwnProperty.call(d, key) && d[key] != null ? String(d[key]) : key;
  if (!vars) return s;
  return s.replace(/\{(\w+)\}/g, (m, k) => (vars[k] !== undefined && vars[k] !== null ? String(vars[k]) : m));
}

/** Plural über `<key>_one` / `<key>_other`. */
export function plural(key, n, vars = {}) {
  return t(key + (Number(n) === 1 ? '_one' : '_other'), { n: fmtNum(n), ...vars });
}

export const lang = () => load()._lang || (typeof document !== 'undefined' && document.documentElement.lang) || 'de';
export const locale = () => load()._locale || 'de-DE';
// Formatierer je Sprache und Optionen merken: neu angelegt kosteten sie im Platz-Detail ~20 ms (dutzende Aufrufe).
const FMT = new Map();
// Art als fester Schlüssel und die Klasse selbst — nicht über Kind.name: ersetzte Klassen (Uhr-Attrappen, Polyfills)
// heißen anders, und Intl[name] fand dann nichts (die Seite brach ab).
function cachedFmt(kind, Kind, opts) {
  const key = kind + '|' + locale() + '|' + (opts ? JSON.stringify(opts) : '');
  let f = FMT.get(key);
  if (!f) { f = new Kind(locale(), opts); if (FMT.size > 200) FMT.clear(); FMT.set(key, f); }
  return f;
}
export const fmtNum = (n, opts) => cachedFmt('num', Intl.NumberFormat, opts).format(Number(n) || 0);
export const fmtDate = (d, opts = { day: 'numeric', month: 'short', year: 'numeric' }) => {
  // Reiner Kalendertag ('YYYY-MM-DD') als LOKALES Datum lesen — new Date('2026-06-15') wäre UTC-Mitternacht
  // und zeigte westlich von Greenwich den Vortag.
  const m = typeof d === 'string' && /^(\d{4})-(\d{2})-(\d{2})$/.exec(d);
  const x = m ? new Date(+m[1], +m[2] - 1, +m[3]) : d instanceof Date ? d : new Date(d);
  return isNaN(x) ? '' : cachedFmt('date', Intl.DateTimeFormat, opts).format(x);
};
